module.exports = __webpack_public_path__ + "img/Karibik.b1208623.jpg";